import { GameState } from "../../GameState"
import { Buttons } from "../../generic-sprites/Buttons"
import { CameraZoom } from "../../utils/CameraZoom"
import { Scale } from "../../utils/Scale"
import { Sprites } from "../../utils/Sprites"
import { MapImages } from "../MapAssets"

export class MapBuilding {

    game: Phaser.Game
    group: Phaser.Group
    sprite: Phaser.Sprite
    highlight: Phaser.Sprite
    onClick: () => void
    asset: string
    x: number
    y: number
    scale: number

    static mapBuildingFactory = (game: Phaser.Game, scale: number, group: Phaser.Group) => {
        return (
            x: number, y: number, asset: MapImages
        ) => {
            const mapBuilding = new MapBuilding()
            mapBuilding.game = game

            mapBuilding.highlight = Sprites.add(game, MapImages.YELLOW_HIGHLIGHT, { group })
            mapBuilding.highlight.alpha = 0
            mapBuilding.sprite = Sprites.add(game, asset, {x, y, debug: true, scale, group})
            mapBuilding.asset = asset
            mapBuilding.x = x
            mapBuilding.y = y
            mapBuilding.scale = scale

            return mapBuilding
        }
    }

    activate = (gameState: GameState) => {

        this.onClick = () => {
            CameraZoom.resetZoom(this.game)
            this.game.state.start(gameState, true, true)
        }

        CameraZoom.zoom(this.game, this.sprite, 1000, Scale.width() * 0.1)
        window.setTimeout(() => {
            Sprites.fadeInAndOut(this.highlight, {fadeDuration: 1000})
            Sprites.centerSpriteInSprite(this.sprite, this.highlight)
            const button = Sprites.add(this.game, this.asset, {x: this.x, y: this.y, scale: this.scale})
            button.alpha = 0
            Buttons.makeSpriteButton(button, this.onClick)
        }, 1000)
    }
}
